import React from 'react'
import { Box, Typography, styled } from '@mui/material'

const Row = styled(Box)({
  display: 'flex',
  alignItems: 'baseline',
  gap: 12,
  marginBottom: 16,
})

const H2 = styled(Typography)({
  fontSize: 18,
  fontWeight: 720,
  letterSpacing: '-0.025em',
  color: 'var(--ds-ink)',
})

const Mono = styled('span')({
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 9.5,
  letterSpacing: '0.1em',
  color: 'var(--ds-ink-subtle)',
  textTransform: 'uppercase',
})

const SeeAll = styled('button')({
  marginLeft: 'auto',
  fontSize: 12,
  fontWeight: 620,
  color: 'var(--ds-accent-deep-b, #8b5cf6)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  '&:hover': { textDecoration: 'underline' },
})

export interface ProfileSectionHeaderProps {
  title: React.ReactNode
  aside?: React.ReactNode
  seeAllLabel?: string
  onSeeAll?: () => void
  sx?: object
}

export function ProfileSectionHeader({ title, aside, seeAllLabel = 'See all →', onSeeAll, sx }: ProfileSectionHeaderProps) {
  return (
    <Row sx={sx}>
      <H2>{title}</H2>
      {aside && <Mono>{aside}</Mono>}
      {onSeeAll && <SeeAll onClick={onSeeAll}>{seeAllLabel}</SeeAll>}
    </Row>
  )
}
